import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import WizardButtons from '../../wizard/navigator/buttons';

import './rejectICW2.css';

class RejectICW2Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true
        };

        this.isFormValid = this.isFormValid.bind(this);
    }

    isFormValid() {
        return true;
    }

    render() {
        const { onSubmit, handleSubmit, cancel, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row" />

                <WizardButtons
                    disabled={submitting || !this.isFormValid()}
                    back={{ action: cancel, message: <FormattedMessage {...messages.cancel} /> }}
                    submit={{ message: <FormattedMessage {...messages.confirm} /> }}
                />
            </form>
        );
    }
}

RejectICW2Form.defaultProps = {
    job: {},
    onSubmit: undefined
};

RejectICW2Form.propTypes = {
    job: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired
};

RejectICW2Form = reduxForm({
    form: 'reject-form',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false
})(RejectICW2Form);

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(RejectICW2Form);



// WEBPACK FOOTER //
// ./src/components/forms/rejectICW2/index.jsx